import { ForwardedRef, forwardRef, InputHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'

interface ColorPickerProps extends InputHTMLAttributes<HTMLInputElement> {
  currentColor: string
}

export const ColorPicker = forwardRef(
  (
    { currentColor, ...rest }: ColorPickerProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const { t } = useTranslation()

    return (
      <div className="mt-4">
        <p className="mb-2 block text-[18px] font-medium capitalize">
          {t('color')}
        </p>
        <label className="flex w-fit cursor-pointer items-center gap-4 rounded-lg text-[18px] font-medium focus-within:border-blue-600">
          <div
            className={`relative flex h-10 w-10 min-w-10 cursor-pointer items-center justify-center overflow-hidden rounded-lg`}
            style={{ background: currentColor }}
          >
            <input
              type="color"
              className="absolute inline-block h-full w-full cursor-pointer rounded-lg focus:border-blue-600 focus:outline-blue-600"
              {...rest}
              ref={ref}
            />
            <div
              className="pointer-events-none absolute left-1/2 top-1/2 h-[97%] w-[97%] -translate-x-1/2 -translate-y-1/2 rounded-lg "
              style={{ background: currentColor }}
            ></div>
          </div>
          <span className="order-blue-500 w-full max-w-[126px] rounded-md border px-4 py-1.5 shadow-md ">
            {currentColor}
          </span>
        </label>
      </div>
    )
  },
)
